<template>
  <v-card class="pa-3">
    <v-card-title>Permanently Delete Account</v-card-title>

    <v-card-text>
      Are you sure? This option is not reversible.<br />
      Enter your password to confirm.
    </v-card-text>

    <v-text-field v-model="password" label="password" type="password"></v-text-field>

    <v-card-actions>
      <v-btn @click="$emit('close')" text>cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="deleteAccount()" color="danger" text>Delete</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import sessionTools from "../mixins/sessionTools";

export default {
  name: "delete-account-dialog.vue",

  mixins: [sessionTools],

  data: function () {
    return {
      password: "",
    };
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    deleteAccount() {
      this.$axios
        .delete("/account", {
          params: {
            password: this.password,
          },
        })
        .then(() => {
          this.showSnackbar({
            text: "Account deleted",
          });
          this.logout();
        });
    },
  },
};
</script>

<style scoped></style>
